/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd. <legal@vecros.com>
 * Proprietary and confidential.
 **********************************************************************************/

import React from "react";
import { Box, Typography, IconButton, Tooltip, useTheme } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useAssistant } from "../AssistantContext";

/** Navbar entry point. Opens the assistant panel. */
export default function AssistantLauncher() {
  const theme = useTheme();
  const { openPanel, open } = useAssistant();

  return (
    <Tooltip title="AI Assistant" arrow>
      <IconButton
        aria-label="Open AI Assistant"
        onClick={() => openPanel()}
        sx={{
          borderRadius: "12px",
          padding: "6px 10px",
          opacity: open ? 1 : 0.85,
          backgroundColor: open ? theme.palette.tertiary.main : "transparent",
          "&:hover": { opacity: 1, backgroundColor: theme.palette.tertiary.main },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <AutoAwesomeIcon sx={{ fontSize: "20px", color: theme.palette.text.color }} />
          <Typography sx={{ color: theme.palette.text.color, fontSize: 14 }}>Assistant</Typography>
        </Box>
      </IconButton>
    </Tooltip>
  );
}
